import NiceModal from '@ebay/nice-modal-react'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { getBuyMBCStatus } from 'state/nfts/api'
import { useUserData } from 'state/user/hooks/useUserData'
import ModalWaitingBuyMBC from 'views/Invesment/components/ModalWaitingBuyMBC'

const CheckBuyMBC = () => {
  const userInfo = useUserData()
  /**
   * api
   * ====================================================================
   */

  const { data, isFetched } = useQuery(['buy-mbc-status'], getBuyMBCStatus, { enabled: !!userInfo })

  useEffect(() => {
    if (isFetched && ['PROCESSING', 'SWAPPING']?.includes(data?.status)) {
      NiceModal.show(ModalWaitingBuyMBC)
    }
  }, [data])

  return null
}

export default CheckBuyMBC
